import { trackLeadCreatedResponse } from "../../../shared/openaiLeadTracking.mjs";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { toast } from "react-toastify";
// import { Player } from "@lottiefiles/react-lottie-player";

import dynamic from "next/dynamic";
import { trackLeadHybrid } from "@/lib/metaLeadTracking";
import LeadOtpVerification from "@/components/common/LeadOtpVerification";

const Player = dynamic(
  () => import("@lottiefiles/react-lottie-player").then((mod) => mod.Player),
  { ssr: false }
);

export default function LearningSelection() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);

  const CRM_API_URL = process.env.NEXT_PUBLIC_ADMIN_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isOtpVerified) {
      toast.error("Please verify your phone via WhatsApp OTP before submitting.");
      return;
    }

    try {
      const [crmResponse] = await Promise.all([
        axios.post(`${CRM_API_URL}/api/leads`, {
          name,
          phone,
          email,
          state,
          city,
          leadSource: "Home page",
        }).then((response) => {
          trackLeadCreatedResponse(response);
          return response;
        }),
        // stop syanamte submission
        // axios.post(
        //   `${process.env.NEXT_PUBLIC_API_URL}/api/contacts/upsert`,
        //   {
        //     fullName: name,
        //     phone: phone,
        //     email,
        //     state,
        //     city,
        //     tags: "Home page",
        //   }
        // ),
      ]);

      if (crmResponse.data.success) {
        await trackLeadHybrid({
          email,
          phone,
          value: 49,
          currency: "INR",
          eventSourceUrl: "/thank-you",
          dedupeKey: `Home page_${phone}_${email}`,
          customData: {
            lead_source: "Home page",
            city,
            state,
          },
        });

        setSubmitted(true);

        // Clear form inputs after submission
        setName("");
        setPhone("");
        setEmail("");
        setState("");
        setCity("");

        // Reset the form after 5 seconds
        setTimeout(() => {
          setSubmitted(false);
        }, 5000);
      } else {
        toast.error(`Unable to submit form, please try again later.`);
      }
    } catch (error) {
      toast.error(`Unable to submit form, please try again later.`);
      console.error(`Error while making API request to CRM: ${error.stack}`);
    }
  };

  const handlePhoneChange = (value) => {
    if (value.match(/^\d{0,10}$/)) {
      setPhone(value);
    }
  };

  const statesOfIndia = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Delhi",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  return (
    <section className="py-12 bg-gray-50  ">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2
            className="sm:text-3xl text-2xl font-bold text-[#1F2937] text-[28.125px] mt-10"
          >
            Experience Personalised Counseling{" "}
            <span className="predict-highlight">Services</span>
          </h2>
          <p
            className="mt-2 text-md text-gray-600 text-[15px]"
          >
            Share your details for tailor-made advice just for you!
          </p>
        </div>

        {/* Adding gap-x-16 for large screens, vertical stacking for mobile with flex-col-reverse */}
        <div className="flex flex-col-reverse md:flex-row items-center justify-center xl:gap-x-28  mx-auto max-w-6xl">
          {/* Left: Form */}
          <div className="flex-1 rounded-lg p-8 md:p-6 lg:p-8 flex flex-col justify-center max-w-lg w-full">
            {!submitted ? (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <input
                    type="text"
                    placeholder="Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-left focus:ring-[#ff9245] focus:border-[#ff9245]"
                    required
                    style={{ textIndent: "10px" }}
                  />
                </div>

                <LeadOtpVerification
                  phone={phone}
                  otpEnabled={false}
                  onPhoneChange={handlePhoneChange}
                  inlinePhoneField
                  phonePlaceholder="Phone"
                  phoneInputClassName="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-left focus:ring-[#ff9245] focus:border-[#ff9245]"
                  onVerifiedChange={setIsOtpVerified}
                />

                <div>
                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-left focus:ring-[#ff9245] focus:border-[#ff9245]"
                    required
                    style={{ textIndent: "10px" }}
                  />
                </div>

                <div>
                  <label htmlFor="state" className="sr-only">
                    Select your state
                  </label>
                  <select
                    id="state"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-left focus:ring-[#ff9245] focus:border-[#ff9245] bg-white text-gray-700"
                    required
                    style={{ textIndent: "10px" }}
                  >
                    <option value="" disabled>
                      Select your state
                    </option>
                    {statesOfIndia.map((state, index) => (
                      <option key={index} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <input
                    type="text"
                    placeholder="City"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-left focus:ring-[#ff9245] focus:border-[#ff9245]"
                    style={{ textIndent: "10px" }}
                    required
                  />
                </div>

                <div className="pt-2 flex justify-center">
                  <button
                    type="submit"
                    disabled={!isOtpVerified}
                    className="px-4 py-2 text-white bg-[#ff9245] rounded-3xl hover:bg-orange-500 transition duration-150 ease-in-out disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-[#ff9245]"
                    style={{ fontSize: "15px" }}
                  >
                    Submit Now
                  </button>
                </div>
              </form>
            ) : (
              <div className="text-center">
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  size="3x"
                  color="#ff9245"
                  className="animate-bounce"
                />
                <p className="mt-4 text-lg font-medium text-gray-700">
                  Thank you for your submission! We will contact you soon.
                </p>
              </div>
            )}
          </div>

          {/* Right: Lottie Animation */}
          <div className="flex-1  flex justify-center max-w-lg w-full h-[400px] sm:pb-24">
            <Player
              autoplay
              loop
              src="https://lottie.host/df0f78d4-f2ec-4759-9a1b-d81f6cd24a7d/1wsI7c0kfb.json"
              style={{ height: "100%", width: "100%" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
